module.exports = "/_next/static/images/cm-b4c9e39c20abe11763fccf93b5eb45bd.svg";